import { render, staticRenderFns } from "./SimpleOrAdvancedAddTransforms.vue?vue&type=template&id=6a928054&"
import script from "./SimpleOrAdvancedAddTransforms.vue?vue&type=script&lang=js&"
export * from "./SimpleOrAdvancedAddTransforms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports